import { useQuery } from '@apollo/client'
import { compose, map, pathOr } from 'ramda'
import { cursorFetchMore, getNodes, getPageInfo } from 'utils/paginationHelper'
import CHATS from 'apollo/queries/CHATS'

const getChatOptions = chatsData => {
  if (!chatsData) return []

  const chats = compose(getNodes(['chats']))(chatsData)

  return map(chat => {
    const memberUser = pathOr({}, ['member_user'], chat)
    const firstName = pathOr('', ['first_name'], memberUser)
    const lastName = pathOr('', ['last_name'], memberUser)
    const memberName = `${firstName} ${lastName}`.trim()

    return {
      id: chat.id,
      value: chat.id,
      label: `Chat #${chat.id}${memberName ? ` - ${memberName}` : ''}`
    }
  }, chats)
}

const useChatSelect = ({ memberId }) => {
  const {
    loading: chatsLoading,
    data: chatsData,
    fetchMore
  } = useQuery(CHATS, {
    variables: {
      filters: {
        member_id: memberId,
        only_active: true
      },
      order: 'reverse_last_message'
    },
    skip: !memberId
  })

  const onPopupScroll = event => {
    const { target } = event
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      const pageInfo = getPageInfo(['chats'])(chatsData)
      if (!pageInfo.hasNextPage) return

      cursorFetchMore(fetchMore)({
        dataPath: ['chats'],
        dataType: 'nodes',
        pageInfo
      })
    }
  }

  const chatOptions = getChatOptions(chatsData)

  return {
    functions: {
      onPopupScroll
    },
    data: {
      chatOptions,
      loading: chatsLoading
    }
  }
}

export default useChatSelect
